import { memo, type ReactNode } from "react";

const SummaryFrame = (props: { num: number; name: ReactNode; children?: ReactNode; containerClassName?: string }) => {
  const { num, name, children, containerClassName } = props;
  return (
    <div className="scha__lc-summary__frame">
      <div className="scha__lc-summary__frame__title">
        <span className={"f-pre"}>{num}. </span>
        <span>{name}</span>
      </div>
      {children && (
        <div className={"scha__lc-summary__step-" + num + " pt-2 " + containerClassName ? containerClassName : ""}>
          {children}
        </div>
      )}
    </div>
  );
};

export default memo(SummaryFrame);
